<template>
<div class='slide slide--basic-content slide-basic-content'>
  <h2 class='slide-basic-content_title'>
    {{ label }}
  </h2>

  <div
    class='slide-basic-content_body'
    :class='container_classes'
    v-html='activity.content'
  />

  <!-- Resource Carousel -->
  <div
    v-if='has_resources && !is_vertical_hype'
    class='slide-basic-content_resources'
  >
    <ResourcesCarousel
      :resources='slide.resources'
      :show_headline='slide.resource_carousel_headline_visible'
      context='basic'
      :toggleActivityOverlay='toggleResourceOverlay'
    />
  </div>
</div>
</template>

<script>
import CommonMixin from './common-mixin'
import HypeDetectorMixin from '../../components/activities/hype-detector-mixin'
import ResourcesCarousel from '../course/resources-carousel'

export default {
  mixins: [CommonMixin, HypeDetectorMixin],

  components: {
    ResourcesCarousel
  },

  data() {
    return {
      canAdvance: false,
      canScroll:  false
    }
  },

  computed: {
    label() {
      return this.activity.label || this.$t('basic_content')
    },

    has_resources() {
      return this.slide && this.slide.resources && this.slide.resources.length
    },

    // Vertical Hype slides suppress the resource carousel (PDEV-23437).
    is_vertical_hype() {
      const orientation = this.activity && this.activity.hype_orientation
      return orientation === 'vertical' || orientation === 'vertical_locked'
    },

    has_quote() {
      return this.activity.content && this.activity.content.match(/slide-article_headline/)
    },

    container_classes() {
      const classes = []
      if (this.has_resources) classes.push('has-resources')
      if (this.has_quote) classes.push('slide-basic-content_body--quote')
      return classes
    }
  },

  methods: {
    becameVisible() {
      this.markSlideAsViewed()

      const el = this._contentElement()
      if (el.offsetHeight === el.scrollHeight) {
        this.canAdvance = true
      } else {
        el.scrollTop = 0
        setTimeout(function() {
          this.canScroll = true
        }.bind(this), 1500)
      }
      this.hypeBecameVisible()
    },

    becameHidden() {
      this.canScroll = false
      this.canAdvance = false
      this.hypeBecameHidden()
    },

    scrollSlide(event) {
      event.preventDefault && event.preventDefault()
      event.stopPropagation && event.stopPropagation()

      const delta = this._getScrollDelta(event)
      const el = this._contentElement()
      const pos = el.scrollTop + el.offsetHeight

      if ((delta >= 0 && pos < el.scrollHeight) || (delta < 0 && el.scrollTop > 0)) {
        if (this.canScroll) {
          this.canAdvance = false
          el.scrollTop = el.scrollTop + delta
        }
      } else {
        if (this.canAdvance) {
          CommonMixin.methods.scrollSlide.bind(this)(event)
        } else {
          this._markCanAdvance()
        }
      }
    },

    _contentElement() {
      return this.$el.getElementsByClassName('slide-basic-content_body')[0]
    },

    _markCanAdvance(delay = 1500) {
      setTimeout(function() {
        this.canAdvance = true
      }.bind(this), delay)
    }

  }
}
</script>

<style lang='sass' scoped>
@import './basic-content-v1'
</style>
